export const SAML_ATTRIBUTES = [
  'id',
  'name',
  'display_name',
  'email',
  'role',
  'avatar',
];
